import { observer } from "mobx-react-lite"
import { Button, Group } from "@mantine/core"
import { Link, useParams } from "react-router-dom"
import { PATHS } from "../../../shared/lib/paths"
import { InstructorStore } from "../../../app/store"
import { useFormContext } from "./formContext"

export const FormActions = observer(function FormActions() {
  const { instructorId } = useParams<{ instructorId?: string }>()
  const form = useFormContext()

  return (
    <Group position="center" my="xl">
      <Button disabled={!form.isDirty() || !form.isValid()} type="submit">
        {instructorId ? "Обновить" : "Добавить"}
      </Button>
      <Button
        disabled={InstructorStore.isLoading}
        variant="light"
        color="gray"
        component={Link}
        to={PATHS.DASHBOARD.INSTRUCTORS.ROOT}
      >
        Назад
      </Button>
    </Group>
  )
})
